import { Button, Grid } from "@mui/material";
import CustomText from "components/typography/CustomText";
import { ERR_NETWORK } from "constants/messages";
import CryptoJS from "crypto-js";
import { ENCRYPT_KEY } from "lib/apiSecret";
import { isEmpty } from "lodash";
import { getUserSubscriptions } from "models/subscriptionsModel";
import { getUserWeeklySlots } from "models/weeklySlotsModel";
import { useSnackbar } from "notistack";
import HistoryTimeline from "pages/subscriptions/details/HistoryTimeline";
import { useEffect, useState } from "react";
import { openLoading } from "store/reducers/tools";
// import CustomerInfo from "./CustomerInfo";
import CustomLink from "components/CustomLink";
import { FRONT_URL } from "lib/global";
import { passwordRestMail } from "models/mailModel";
import { getCustomerLogs } from "models/usersModel";
import CustomerInfo from "pages/subscriptions/details/CustomerInfo";
import CustomerPayment from "./CustomerPayment";

export default function CustomerDetailsComponent({ userInfo = {} }) {
  const { enqueueSnackbar } = useSnackbar();
  const [boxes, setBoxes] = useState([]);
  const [invoiceData, setInvoiceData] = useState([]);
  const [user, setUser] = useState({});
  const [logs, setLogs] = useState({});
  const [openLink, setOpenLink] = useState("");

  const loadData = () => {
    getUserSubscriptions({
      user_id: userInfo?.id ?? "",
      onFinish: (res, err) => {
        openLoading(false);
        if (res === false) {
          if (!res && err?.message) {
            enqueueSnackbar(err?.message, { variant: "warning" });
          } else {
            enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
          }
          return;
        }
        setBoxes(res);
      },
    });
    getUserWeeklySlots({
      data: { userid: userInfo?.id ?? "" },
      onFinish: (res, err) => {
        if (res !== false) {
          setInvoiceData(res);
        }
      },
    });
    getCustomerLogs({
      data: { user_id: userInfo?.id ?? "" },
      onFinish: (res, err) => {
        if (res === false) return;
        setLogs(res ?? {});
      },
    });
  };

  const handleResetPassword = () => {
    openLoading(true);
    passwordRestMail({
      username: user?.name ?? "",
      email: user?.email ?? "",
      onFinish: (res, err) => {
        openLoading(false);
        if (res !== false)
          enqueueSnackbar("Email sent successfully", { variant: "success" });
        else enqueueSnackbar(ERR_NETWORK.LONG, { variant: "warning" });
      },
    });
  };

  const handleEditUser = (res, logData) => {
    setUser(res);
    if (Boolean(logData?.log))
      setLogs((prev) => ({
        ...prev,
        pieclub: [logData, ...(prev?.pieclub ?? [])],
      }));
  };

  const handleSendNote = (log) => {
    setLogs((prev) => ({ ...prev, pieclub: [log, ...(prev?.pieclub ?? [])] }));
  };

  useEffect(() => {
    if (isEmpty(userInfo)) return;
    loadData();
    setUser(userInfo);
    const cipherText = CryptoJS.AES.encrypt(
      JSON.stringify({ uuid: userInfo?.id ?? "" }),
      ENCRYPT_KEY
    )
      .toString()
      .replace(/\//g, "Por21Ld");
    setOpenLink(cipherText);
    //eslint-disable-next-line
  }, [userInfo]);

  return (
    <div>
      <Grid container spacing={2}>
        <Grid className="" item lg={3} md={3} sm={12} xs={12}>
          <CustomerInfo
            data={{
              ...user,
              user_joined: user.created_at,
              user_id: user.id,
              user_status: user?.status ?? "1",
            }}
            type="user-detail"
            // totalSpent={invoiceData.reduce((ret, cur) => ret + +cur?.amount, 0)}
            onEditUser={handleEditUser}
            onChangePhoneCode={(v) =>
              setUser((prev) => ({ ...prev, phone_code: v }))
            }
          />
          <div className="pt-5">
            <CustomText className="text-xs">PASSWORD RESET</CustomText>
            <Button
              className="mt-4"
              variant="contained"
              color="secondary"
              onClick={handleResetPassword}
            >
              Send Password Reset Mail
            </Button>
          </div>
          <div>
            <CustomLink target="_blank" to={`${FRONT_URL}/account/${openLink}`}>
              <Button className="my-4" variant="contained" color="secondary">
                Open Account
              </Button>
            </CustomLink>
          </div>
          <div className="flex items-center">
            <CustomLink
              target="_blank"
              to={`https://account.postmarkapp.com/servers/8736174/streams/outbound/addresses/${userInfo?.email?.replace(
                /@/g,
                "%2540"
              )}`}
            >
              <Button variant="contained" color="secondary">
                Postmark
              </Button>
            </CustomLink>
            {userInfo?.customer_id && (
              <CustomLink
                target="_blank"
                to={`https://dashboard.stripe.com/customers/${userInfo?.customer_id}`}
              >
                <Button className="mx-2" variant="contained" color="secondary">
                  Stripe
                </Button>
              </CustomLink>
            )}
          </div>
        </Grid>
        <Grid item lg={9} md={9} sm={12} xs={12}>
          <CustomerPayment
            userInfo={userInfo}
            boxes={boxes}
            invoiceData={invoiceData}
          />
          <HistoryTimeline
            title="Activity Timeline"
            logs={logs}
            user={user}
            onSend={handleSendNote}
          />
        </Grid>
      </Grid>
    </div>
  );
}
